const routes = {
  path: '/work-flow',
  component: () => import('@/components/layout/index.vue'),
  alwaysShow: true,
  meta: {
    title: '业务流程',
    icon: 'iconziyuan'
  },
  children: [
    {
      path: 'follow/list',
      name: 'Follow',
      component: () => import('@/views/workFlow/follow/index.vue'),
      meta: {
        title: '跟进记录',
      }
    },
    {
      path: 'commercial/list',
      name: 'Commercial',
      component: () => import('@/views/workFlow/commercial/index.vue'),
      meta: {
        title: '商机列表',
        permission: 'customer.business',
      }
    },
    {
      path: 'order/list',
      name: 'OrderList',
      component: () => import('@/views/workFlow/order/index'),
      meta: {
        title: '订单列表',
        permission: 'customer.order'
      }
    },
    {
      path: 'approve/index',
      name: 'ApproveIndex',
      component: () => import('@/views/workFlow/approve/index'),
      meta: {
        title: '审批列表',
        type: 'approve',
        permission: 'voucher'
      }
    }
  ]
}
export default routes;